import { render, staticRenderFns } from "./ChartsInforme.vue?vue&type=template&id=8c0908f8&"
import script from "./ChartsInforme.vue?vue&type=script&lang=js&"
export * from "./ChartsInforme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports